import { useLocation, Outlet } from "react-router-dom";
import {
  Package, Box, Building2, Truck, ClipboardList
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  {
    id: "inventory",
    label: "Inventory",
    icon: Box,
    path: "/logistics/inventory",
    description: "Equipment & asset tracking",
  },
  {
    id: "offices",
    label: "Offices & Parking",
    icon: Building2,
    path: "/logistics/offices",
    description: "Office & parking management",
  },
  {
    id: "fleet",
    label: "Fleet",
    icon: Truck,
    path: "/logistics/fleet",
    description: "Vehicle fleet management",
  },
  {
    id: "scm",
    label: "SCM",
    icon: ClipboardList,
    path: "/logistics/scm",
    description: "Supply chain & procurement",
  },
];

export default function LogisticsHubLayout() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="LOGISTICS HUB"
        subtitle="Supply Chain & Assets"
        icon={Package}
        gradient="from-amber-500 to-orange-600"
        activeBg="bg-amber-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
